module.exports = __webpack_public_path__ + "63fff6b7536e843452ae95b82b28402d.svg";